import { VivoPlotProps } from "@/components/VivoPlots/types";
import { SortItem } from "@/components/UI/TableToolbar/Sorting/types";

export type DashboardBreakpoint = "lg" | "md" | "sm" | "xs";

export type PlotLayoutItem = {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
  minW?: number;
  minH?: number;
  maxW?: number;
  maxH?: number;
  static?: boolean;
  isDraggable?: boolean;
  isResizable?: boolean;
};

export type PlotLayoutsByBreakpoint = Partial<
  Record<DashboardBreakpoint, PlotLayoutItem[]>
>;

export type TableFilterPrimitive = string | number | boolean | null;
export type TableFilterObject = Record<string, unknown>;
export type TableFilterValue = Array<
  TableFilterPrimitive | TableFilterObject | TableFilterValue
>;
export type TableFilters = Record<string, TableFilterValue>;

export type TableState = {
  filters: TableFilters;
  columns: ColumnsType[];
  lockedColumns: number;
  sorting?: SortItem[];
  pagination: {
    current: number;
    pageSize: number;
    total?: number;
  };
  plots?: VivoPlotProps[] | [];
  plotLayoutsByBreakpoint?: PlotLayoutsByBreakpoint;
  screenView?: string;
  version?: string;
  workspaceId?: number;
  workspaceModifiedAt?: string;
};

export type TableStateFunctions = {
  setPlots: (plots: VivoPlotProps[]) => void;
  setPlotLayoutsByBreakpoint: (layouts: PlotLayoutsByBreakpoint) => void;
  setFilter: (filter: TableFilters) => void;
  setFilters: (filters: TableFilters) => void;
  setColumn: (columns: ColumnsType[]) => void;
  setSorting: (sorting: SortItem[]) => void;
  reset: (overrideState?: TableState, callback?: () => void) => void;
  clearLocalStorage: () => void;
  setLockedColumns: (lockedColumns: number) => void;
  setPagination: (pagination: {
    current: number;
    pageSize: number;
    total: number;
  }) => void;
  setScreenView: (screenView: string) => void;
  setWorkspaceMeta: (workspaceId: number, workspaceModifiedAt: string) => void;
};

export enum ColumnVisibility {
  VISIBLE = "visible",
  HIDDEN = "hidden",
  NOT_AVAILABLE = "not_available",
}

export type ColumnsType = {
  fieldName: string;
  visibility: ColumnVisibility;
  mandatory?: boolean;
};
